import { Navigate } from "react-router-dom";
import { ADMIN_PATH } from "src/themeLayouts";
import useIsCaseManagementEnabled from "../hooks/useIsCaseManagementEnabled";

/**
 * Route guard for the case-management (Dial) surface. Every authenticated admin
 * can enter; other account types are redirected to the admin home.
 */
export default function CaseManagementGate({
  children,
}: {
  children: JSX.Element;
}): JSX.Element {
  const { isEnabled } = useIsCaseManagementEnabled();

  if (!isEnabled) return <Navigate to={ADMIN_PATH} replace />;

  return children;
}
